/**
 * <dialog-component id="tm-welcome-popup" data-delay="3500"> (see
 * snippets/tm-welcome-popup.liquid)
 *
 * Opens the welcome-offer popup once per browser, a few seconds after the
 * page loads. The seen flag is written the moment it opens (not on
 * dismiss), so a shopper who ignores it isn't shown it again on every page.
 *
 * Skipped inside the theme editor, and whenever another dialog is already
 * open (size guide, search, quick add, ...) -- in that case it isn't marked
 * seen, so it still gets its chance on a later page.
 */
const SEEN_KEY = 'tm-welcome-popup-seen';

function safeGet(key) {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeSet(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Storage blocked (private mode on some browsers) -- popup may repeat; harmless.
  }
}

async function init() {
  const popup = document.getElementById('tm-welcome-popup');
  if (!popup) return;
  if (window.Shopify?.designMode) return;
  if (safeGet(SEEN_KEY)) return;

  await customElements.whenDefined('dialog-component');

  const delay = Number(popup.dataset.delay) || 3500;

  setTimeout(() => {
    if (safeGet(SEEN_KEY)) return;
    if (document.querySelector('dialog[open]')) return;

    // Belt-and-suspenders: dialog-styles.liquid's
    // shared .dialog-modal rule forces a full-screen sheet below 750px, so
    // the 1:1 square size is also applied as an inline !important style,
    // which nothing in an external stylesheet can out-rank.
    const dialogEl = popup.querySelector('dialog');
    if (dialogEl) {
      dialogEl.style.setProperty('height', 'auto', 'important');
      dialogEl.style.setProperty('aspect-ratio', '1 / 1', 'important');
      dialogEl.style.setProperty('max-height', '85vh', 'important');
      dialogEl.style.setProperty('width', 'min(92vw, 25rem)', 'important');
      dialogEl.style.setProperty('max-width', '25rem', 'important');
      dialogEl.style.setProperty('margin', 'auto', 'important');
    }

    safeSet(SEEN_KEY, '1');
    popup.showDialog();
  }, delay);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
